import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UsersSelector } from '../../../components';
import { setSelectedUsers } from '../../../actions/TVModeAction';
import { Icon, Avatar } from '@material-ui/core';

class TVModeModalRecipientComponent extends Component {
  state = {
    selectedUsers: [],
    focused: true
  }

  usersSelector = null;

  componentDidMount() {
    this.setState({ selectedUsers: this.props.selectedUsers });
  }

  setUsers(users) {
    this.setState({ selectedUsers: users });
    this.props.setSelectedUsers(users);
  }

  findIfFocused() {
    if (this.usersSelector && this.usersSelector.userDropdown &&
      this.usersSelector.userDropdown.dropdownInput && this.usersSelector.userDropdown.dropdownInput.current) {
      this.setState({ focused: this.usersSelector.userDropdown.dropdownInput.current === document.activeElement });
    }
    else this.setState({ focused: false });
  }

  renderChips() {
    return this.state.selectedUsers.map(user => {
      const { photoURL } = user;

      user.deleteClick = () => {
        let selectedUsers = this.state.selectedUsers;
        selectedUsers.splice(selectedUsers.map(user => user.key || user.uid).indexOf(user.uid || user.key), 1);
        this.setState({
          ...this.state,
          selectedUsers
        });
      };

      return (
        <div
          className="chip-wrapper"
          key={user.uid || user.key}
        >
          <Avatar className="chip-user-icon" alt="sender" src={photoURL} />
          <span className="chip-user-name">{user.displayName || user.name}</span>
          <Icon
            className="chip-delete"
            onClick={() => user.deleteClick()}
          >
            close
          </Icon>
        </div>
      );
    });
  }

  render() {
    const { users } = this.props;
    const { selectedUsers } = this.state;
    const pickedUids = this.state.selectedUsers.map((user) => user._id);
    const usersToShow = users.filter((user) => pickedUids.indexOf(user._id) === -1 && !user.deactivated);

    return (
      <div onClick={() => this.findIfFocused()}>

        <div className="tv-mode-user-dropdown">
          {this.state.focused && <div className="helper-text">Highlight a recipient</div>}
          <UsersSelector
            ref={ref => this.usersSelector = ref}
            placeholder={this.state.selectedUsers.length === 0 ? "FIND A PERSON TO HIGHLIGHT" : ''}
            users={usersToShow}
            selectedUsers={selectedUsers}
            setSelectedUsers={this.setUsers.bind(this)}
          />
        </div>

      </div>
    );
  }
}
const mapStateToProps = ({ usersStore, tvModeStore }) => {
  const { users } = usersStore;
  return { users, selectedUsers: tvModeStore.users };
};

const TVModeModalRecipient = connect(mapStateToProps, { setSelectedUsers })(TVModeModalRecipientComponent);
export { TVModeModalRecipient };


// WEBPACK FOOTER //
// ./src/screens/dashboard/TVModeModalSections/TVModeModalRecipient.js